
import { ApplyJob } from "../pages/api/API";
import { getUserToken } from "./userfuctions";


export const handleApplyNow = (JobCode) => {
    const AccessToken = getUserToken();
    if (JobCode) {
        ApplyJob(JobCode, AccessToken);
    }
};


